<template>
    <table className="bg-white w-full">
        <ContentHead @sortColumn="sortColumn"
                     :sortBy="sortBy"
                     :columns="columns"
                     :showSortIcon="showSortIcon"
        />
        <ContentBody :opportunities="opportunities"/>
    </table>
</template>

<script>

import ContentBody from "@/Components/Opportunities/Table/Content/Body";
import ContentHead from "@/Components/Opportunities/Table/Content/Head";

export default {
    components: {ContentHead, ContentBody},
    props: ['opportunities', 'sortBy', 'showSortIcon'],
    data: () => ({
        columns: [
            {
                name: 'companyName',
                translationKey: 'opportunities.table_opportunity_name',
            },
            {
                name: 'unixCreatedDate',
                translationKey: 'opportunities.table_opportunity_date',
            },
            {
                name: 'employeeName',
                translationKey: 'opportunities.employee_name',
            },
            {
                name: 'status',
                translationKey: 'opportunities.table_opportunity_status',
            },
        ]
    }),
    methods: {
        sortColumn: function (column) {
            this.$emit('sortColumn', column);
        }
    }
}
</script>
